import { render, staticRenderFns } from "./TextBlock.vue?vue&type=template&id=48d64cb0&scoped=true"
import script from "./TextBlock.vue?vue&type=script&lang=ts"
export * from "./TextBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d64cb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d64cb0')) {
      api.createRecord('48d64cb0', component.options)
    } else {
      api.reload('48d64cb0', component.options)
    }
    module.hot.accept("./TextBlock.vue?vue&type=template&id=48d64cb0&scoped=true", function () {
      api.rerender('48d64cb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/TextBlock.vue"
export default component.exports